<div class="wrap uk-margin-bottom">

    <div class="uk-margin-bottom">
        <div class="day" style="margin-left: -10px;" *ngIf="periodFilter === 0">
            <a uk-slidenav-previous class="vertical-align-super" (click)="prevDate()"></a>
            <span class="main-title"><span class="bold">Planning</span> du <span humanDateFormat="{{ start }}"
                    shortened="true"></span></span>
            <a uk-slidenav-next class="vertical-align-super" (click)="nextDate()"></a>
        </div>

        <div class="week" style="margin-left: -10px;" *ngIf="periodFilter === 1">
            <a uk-slidenav-previous class="vertical-align-super" (click)="prevDate()"></a>
            <span class="main-title"><span class="bold">Planning</span> du <span humanDateFormat="{{ weekStart }}"
                    shortened="true" noDay="true"></span> au <span humanDateFormat="{{ weekEnd }}" shortened="true"
                    noDay="true"></span></span>
            <a uk-slidenav-next class="vertical-align-super" (click)="nextDate()"></a>
        </div>
    </div>

    <div class="uk-grid@m uk-width-1-1" style="margin-left: -20px;">
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block" style="margin-top: 20px;">
                <button class="uk-button round-button uk-display-inline-block"
                    [class.round-button-toggle]="periodFilter === 0" (click)="changePeriodFilter(0)">
                    Jour
                </button>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block"
                    [class.round-button-toggle]="periodFilter === 1" (click)="changePeriodFilter(1)">
                    Semaine
                </button>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block uk-width-expand research-form-controls">
            <div class="uk-form-controls uk-display-inline-block uk-width-1-2">
                <app-datepicker [(date)]="selectedDate" (dateChange)="changeDate($event)"></app-datepicker>
            </div>
            <div class="uk-form-controls uk-display-inline-block uk-width-1-2" style="padding-left: 40px;">
                <select [(ngModel)]="selectedVehicle" class="combo-list" id="form-horizontal-select"
                    style="margin-left: 10px;">
                    <option [ngValue]="-1">Tous les véhicules</option>
                    <option *ngFor="let vehicle of vehicles; let i = index" [ngValue]="i">{{ vehicle.vehicle }}
                    </option>
                </select>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block" style="margin-right: 20px;">
                <button disabled style="padding: 0px 20px 0px 20px; margin-top: -3px;"
                    [attr.uk-tooltip]="'Indisponible'" class="uk-button button uk-display-inline-block">
                    Ajouter un événement<i class="material-icons" style="vertical-align: middle;">add</i>
                </button>
            </div>
        </div>
    </div>

</div>

<div class="canvas uk-position-relative">

    <div class="uk-position-center" *ngIf="loadingStatus === true">
        <div uk-spinner></div>
    </div>

    <div class="wrap bold uk-margin-medium-top" style="margin: auto;"
        *ngIf="loadingStatus === false && vehicles.length === 0">
        Vous n'avez pas de réservations pour cette période.
    </div>

    <div class="uk-position-relative" *ngIf="loadingStatus === false && vehicles.length !== 0">
        <div *ngIf="shouldClockBeDisplayed() === true">
            <div class="clock" [ngStyle]="{ 
                'left' : 'calc((100% / 18 + 1px) * ' + clockOffset + ' + 5px)'
            }">{{ clock }}</div>
            <div class="clockBar" [ngStyle]="{ 
                'left' : 'calc((100% / 18 + 1px) * ' + clockOffset + ' + 5px)'
            }"></div>
        </div>
        <div *ngIf="periodFilter === 0" style="margin-left: 40px; height: 20px;">
            <div class="bar day" uk-grid>
                <div class="width-2-18"></div>
                <div class="width-1-18"><span class="small">7h</span></div>
                <div class="width-1-18"><span class="small">8h</span></div>
                <div class="width-1-18"><span class="small">9h</span></div>
                <div class="width-1-18"><span>10h</span></div>
                <div class="width-1-18"><span>11h</span></div>
                <div class="width-1-18"><span>12h</span></div>
                <div class="width-1-18"><span>13h</span></div>
                <div class="width-1-18"><span>14h</span></div>
                <div class="width-1-18"><span>15h</span></div>
                <div class="width-1-18"><span>16h</span></div>
                <div class="width-1-18"><span>17h</span></div>
                <div class="width-1-18"><span>18h</span></div>
                <div class="width-1-18"><span>19h</span></div>
                <div class="width-1-18"><span>20h</span></div>
                <div class="width-1-18"><span>21h</span></div>
            </div>
        </div>
        <div *ngIf="periodFilter === 1" style="margin-left: 40px; height: 20px;">
            <div class="bar week" uk-grid>
                <div class="width-2-18"></div>
                <div class="width-2-18"><a (click)="zoomToDayView(0)" style="margin-left: -10px;">Lundi</a></div>
                <div class="width-2-18"><a (click)="zoomToDayView(1)" style="margin-left: -10px;">Mardi</a></div>
                <div class="width-2-18"><a (click)="zoomToDayView(2)" style="margin-left: -17px;">Mercredi</a></div>
                <div class="width-2-18"><a (click)="zoomToDayView(3)" style="margin-left: -6px;">Jeudi</a></div>
                <div class="width-2-18"><a (click)="zoomToDayView(4)" style="margin-left: -16px">Vendredi</a></div>
                <div class="width-2-18"><a (click)="zoomToDayView(5)" style="margin-left: -11px;">Samedi</a></div>
                <div class="width-2-18"><a (click)="zoomToDayView(6)" style="margin-left: -15px;">Dimanche</a></div>
                <div class="width-2-18"></div>
            </div>
        </div>
        <div *ngIf="periodFilter === 2" class="bar month"></div>
        <div *ngFor="let vehicle of vehicles; let i = index" style="margin-left: 40px;">
            <div *ngIf="selectedVehicle === -1 || selectedVehicle === i" style="margin-top: inherit;" uk-grid
                class="row" [class.extend-borders-in-week]="periodFilter === 1">
                <div class="width-2-18 matriculation" *ngIf="vehicle.informations[0].id !== 0"
                    [routerLink]="['/ressource/vehicle/informations/' + vehicle.informations[0].id ]">
                    <span>{{ vehicle.vehicle }}</span>
                </div>
                <div class="width-2-18 matriculation" style="color: #4E5A5A; cursor: default;"
                    *ngIf="vehicle.informations[0].id === 0">
                    <span>{{ vehicle.vehicle }}</span>
                </div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div class="width-1-18"></div>
                <div style="border-right: inherit;" *ngFor="let reservation of vehicle.reservations; let i = index">
                    <div class="reservation" [routerLink]="['/reservation/informations/' + reservation.idBooking ]"
                        [routerLink]="['/reservation/informations/' + reservation.idBooking]"
                        [queryParams]="{from: '/', name: 'Tableau de bord'}" [ngStyle]="{
                        'left' : 'calc((100% / 18 + 1px) * ' + reservation.left + ' + 5px)',
                        'width': 'calc((100% / 18 + 1px) * ' + reservation.width + ')'
                        }" [class.background-green]="reservation.status >= 0 && reservation.status <= 2"
                        [class.background-orange]="reservation.status >= 3 && reservation.status <= 10"
                        [class.background-light-special-gray]="reservation.status >= 11 && reservation.status <= 14"
                        [class.background-red]="reservation.status == 20">
                        <span *ngIf="reservation.width >= 1.5" class="hours">{{ reservation.start[0] }} : {{
                            reservation.start[1] }} - {{ reservation.end[0] }} : {{ reservation.end[1] }}</span>
                        <span *ngIf="reservation.width >= 1.5" class="status">
                            <span *ngIf="reservation.status >= 0 && reservation.status <= 4">Réservé</span>
                            <span *ngIf="reservation.status == 20">Annuler</span>
                            <span *ngIf="reservation.status >= 5 && reservation.status <= 10">En cours</span>
                            <span *ngIf="reservation.status >= 9 && reservation.status <= 14"
                                class="color-dark-gray">Terminé</span>
                            <span *ngIf="reservation.status >= 9 && reservation.status <= 14"
                                class="color-dark-gray">Terminé</span>
                            <span *ngIf="reservation.status == 10">Sinistre</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>